import React from "react";
import Box from "@mui/material/Box";
import CardMedia from '@mui/material/CardMedia';
import {Link} from "react-router-dom";

const GeneralTerms = () => {
    return (
        <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        height: '100vh',
      }}
    >
      <Box sx={{ height: 24 }} />
      <Box 
        component="iframe" 
        src="https://getnotionembed.com/embed/6ce629cf-86e8-4d55-90a0-b6bc40874fdc?mode=light"
        sx={{ 
          flex: 1, 
          height: '100vh',
          width: '100%', 
          border: 'none' 
        }}
      />
      
      <Box sx={{ height: 48 }} />
    </Box>

    )
}

export default GeneralTerms;
